import dayjs from 'dayjs'

const EMPTY = [null, undefined, '']

export const parseDate = value => {
  if (EMPTY.includes(value)) return null

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : dayjs(value)
  }

  const fromDayjs = dayjs(value)
  if (fromDayjs.isValid()) return fromDayjs

  const native = new Date(value)
  if (!Number.isNaN(native.getTime())) return dayjs(native)

  return null
}

export const formatDate = (
  value,
  { fallback = '—', format = 'MMM D, YYYY' } = {}
) => {
  const date = parseDate(value)
  return date ? date.format(format) : fallback
}

export const firstDateValue = (...values) =>
  values.find(value => !EMPTY.includes(value))
